module.exports = __webpack_public_path__ + "img/17_1.5f262e07.png";